<template>
  <div class="page-wrapper" :class="{'gray-bg': !list.length}">
    <div class="swiper-content">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in swiperList" :key="index">
          <van-image width="100%" height="245px" fit="fill" :src="item.imgUrl" @click="openLink(item)"/>
          <div class="title">{{item.title}}</div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <van-sticky :z-index="1000">
      <tab-menu v-model="active" @change="handleChange" :isGuide="isGuide"></tab-menu>
    </van-sticky>

    <refresh-list @onLoad="onLoad" :list="list" @onRefresh="init" ref="refreshList" noDataMessage="这里空空如也，快去创建第一个活动吧">
      <div>
        <div v-for="(item, index) in list" :key="index">
          <div class="card-content-lsy" v-if="item.activityTag != '4'">
            <div class="role-tag">{{item.activityTag|tagFormat}}</div>
            <div class="card-media">
              <van-image width="100%" height="130" :src="item.backgroundImg" fit="cover" />
              <div class="badge-text">活动id：{{item.activityId}}</div>
            </div>
            <div class="card-inner">
              <div class="card-title">{{item.activityTitle}}</div>
              <div class="card-right">
                <div class="price" v-if="+item.signUpfee > 0">¥{{item.signUpfee}}</div>
                <div class="price" v-else>免费</div>
              </div>
            </div>
            <div class="card-inner">
              <div class="card-text">
                <div>开始时间：{{item.startTime|dateFormat}}</div>
                <div>结束时间：{{item.endTime|dateFormat}}</div>
              </div>
              <div class="card-right">
                <div class="status">
                  <van-icon :name="timeIcon" class="time-icon" />
                  <span>{{active|formatActive}}</span>
                </div>
              </div>
            </div>
            <template v-if="item.activityStatistic">
              <div class="card-inner process" v-if="+item.activityStatistic.browsePeopleNumberTarget > 0">
                <span>拉新数：</span>
                <van-progress :percentage="item.activityStatistic.newPercent" color="#FF6B31" stroke-width="2" />
                <div>
                  <span class="text-orange">{{item.activityStatistic.newPeopleNumber || 0}}</span>
                  <span>/{{item.activityStatistic.browsePeopleNumberTarget}}</span>
                </div>
              </div>
              <div class="card-inner process" v-if="+item.activityStatistic.signUpNumberTarget > 0">
                <span>报名数：</span>
                <van-progress :percentage="item.activityStatistic.registPercent" color="#FF6B31" stroke-width="2" />
                <div>
                  <span class="text-orange">{{item.activityStatistic.signUpNumber || 0}}</span>
                  <span>/{{item.activityStatistic.signUpNumberTarget}}</span>
                </div>
              </div>
            </template>

            <div class="card-footer" v-if="+active != activityStatusEnum.draft">
              <template v-if="item.activityTag == activityTagEnum.myCreated">
                <div v-if="active == activityStatusEnum.toStarting || active == activityStatusEnum.running" 
                  class="card-btn" 
                  @click="close(item)">关闭</div>
              </template>
              <!-- <template v-else>
                <div class="card-btn" @click="handleActivity(item.activityId, 'view')">查看活动</div>
              </template> -->
              <!-- 非活动老师或数钱特殊角色-->
              <div class="card-btn" v-if="userInfo.countAuthority || !isTeacher" @click="handleActivity(item, 'poster')">海报分享</div>
              <div class="card-btn" @click="handleActivity(item, 'manager')">管理</div>
            </div>
            <!-- 草稿箱 -->
            <div class="card-footer" v-else>
              <div class="card-btn" @click="deleteActivity(item.activityId)">删除</div>
              <div class="card-btn" @click="handleActivity(item, 'edit')">编辑</div>
            </div>
          </div>

          <div class="card-content-lsy" v-else>
            <div class="role-tag">{{item.activityTag|tagFormat}}</div>
            <div class="flex-wrapper">
              <div class="card-media small">
                <van-image width="115" height="95" :src="item.backgroundImg" fit="cover"/>
                <div class="badge-text">活动id：{{item.activityId}}</div>
              </div>
              <div class="flex-grow">
                <div class="card-inner">
                  <div class="card-title">{{item.activityTitle}}</div>
                </div>
                <div class="card-inner">
                  <div class="card-text">
                    <div>开始时间：{{item.startTime|dateFormat('YYYY-MM-DD')}}</div>
                    <div>结束时间：{{item.endTime|dateFormat('YYYY-MM-DD')}}</div>
                  </div>
                </div>
                <div class="card-inner">
                  <div>
                    <template v-if="+item.signUpfee > 0">
                      {{item.signUpfeeLable}}
                      <span class="price">¥{{item.signUpfee}}</span>
                    </template>
                    <span v-else class="price">免费</span>
                  </div>
                  <div class="status" style="margin-top: 0;">
                    <van-icon :name="timeIcon" class="time-icon" />
                    <span>{{active|formatActive}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="card-btn" @click="handleActivity(item, 'manager')">管理</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="no-data">
        <van-button 
          v-if="isTeacher || isDistributor || isShopowner"
          type="default" 
          plain 
          @click="$router.push('/template')" 
          style="margin-top: 15px;">
          立即创建
        </van-button>
      </div>
    </refresh-list>
    <refund-tips />
    <enter-piece-pop />
  </div>
</template>

<script>
import tabMenu from './tab-menu'
import noDataImg from '@/assets/images/img-default@2x.png'
import timeIcon from '@/assets/icons/card_icon_time@2x.png'
import refreshList from '@/components/refresh-list/refresh-list'
import refundTips from './components/refund-tips'
import enterPiecePop from './components/enter-piece-pop'
import moment from 'moment'
import { mapGetters } from 'vuex'
import loadingMixin from '@/mixins/loading-mixin'
import {activityTagEnum, activityStatusEnum} from '@/utils/constant'
export default {
  name: 'Home',
  components: {
    tabMenu,
    refreshList,
    refundTips,
    enterPiecePop
  },
  mixins: [loadingMixin],
  data() {
    return {
      activityTagEnum, 
      activityStatusEnum,
      noDataImg: noDataImg,
      timeIcon: timeIcon,
      active: 2,
      pageNum: 1,
      pageSize: 20,
      swiperList: [],
      list: [],
    }
  },
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide',
      'userInfo'
    ])
  },
  mounted() {
    this.getSwiper();
    this.init();
  },
  methods: {
    onLoad() {
      this.getActivityData();
    },
    onRefresh() {
      setTimeout(_=>{
        this.init();
      },800)
    },
    handleChange() {
      this.init();
    },
    async init() {
      this.pageNum = 1;
      this.list = [];
      this.$refs['refreshList'].reset();
      this.showLoading();
      await this.getActivityData()
        .catch(console.log);
      this.hideLoading();
    },
    getActivityData() {
      let data = {
        filterData: {
          activityName: '',
          dataType: this.active
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      return this.$api.h5.home(data)
        .then(({data}) => {
          let list = data.list;
          if (list) {
            list = list.map(item => {
              if (item.activityStatistic) {
                const {newPeopleNumber, browsePeopleNumberTarget, signUpNumber, signUpNumberTarget} = item.activityStatistic;
                const newPercent = browsePeopleNumberTarget > 0 
                  ? Math.floor((newPeopleNumber || 0) / browsePeopleNumberTarget * 100)
                  : 0;
                item.activityStatistic.newPercent = Math.min(newPercent, 100);
                const registPercent = signUpNumberTarget > 0
                  ? Math.floor((signUpNumber || 0) / signUpNumberTarget * 100)
                  : 0;
                item.activityStatistic.registPercent = Math.min(registPercent, 100);
              }
              return {
                ...item
              };
            });

            this.list.push(...list);
            this.pageNum = data.pageNum + 1;
            this.$refs['refreshList'].complete(data);
          } else {
            this.$refs['refreshList'].onFinish();
          }
        });
    },
    getSwiper() {
      let data = {
        filterData: {
          // 查询上线状态的
          rollingStatus: 0
        },
        pageNum: 1,
        // 最多显示5条
        pageSize: 5
      }
      this.$api.h5.queryRollings(data)
        .then(({data: {list}})=>{
          this.swiperList = list || [];;
        });
    },
    close(item) {
      this.$funcDialog.show({
        content: '请问是否关闭当前活动？<br />关闭后将不可恢复！'
      });
      this.$funcDialog.addEventListener(status=>{
        if(status == 'cancel') return;
        this.$api.h5.closeActivity(item.activityId)
        .then(res=>{
          this.init();
        })
      });
    },
    deleteActivity(id) {
      this.$funcDialog.show({
        content: '请问是否删除当前草稿？<br />删除后不可恢复！'
      });
      this.$funcDialog.addEventListener(status=>{
        if(status == 'cancel') return;
        this.$api.h5.deleteActivity(id)
        .then(res=>{
          this.init();
        })
      });
    },
    to(item, p) {
      this.$router.push({
        path: p,
        query: {
          ...item,
          active: this.active
        }
      })
    },
    // pathType: 1 查看  2 编辑
    handleActivity(item, pathType) {
      const pathMap = {
        view: '/activity-home',
        editBasic: '/activity/edit-basic',
        edit: '/activity/edit',
        manager: '/activety-manager',
        poster: '/activity/promotion-poster'
      }
      const query = {
        activityId: item.activityId,
        from: 'home'
      };
      if (pathType == 'edit' && item.createWay == 'new') {
         pathMap.edit = '/newActivity/create',
         query.creationMode = 'new',
         query.tmpType = item.tmpType || '1'
      }

      if (['editBasic', 'manager'].includes(pathType)) {
        query.activeTab = this.active;
      }
      if (item.status == 3 && pathType == 'poster') {
        this.$toast('当前活动已经结束，无法操作');
      }else {
        this.$router.push({
          path: pathMap[pathType],
          query
        })
      }
    },
    openLink(item) {
      if (!item.imgLinkUrl) {
        return;
      }
      if (item.imgLinkUrl.startsWith('https')) {
        window.location.href = item.imgLinkUrl;
      } else {
        window.location.href = `https://${item.imgLinkUrl}`;
      }
    }
  },
  filters: {
    formatActive(val) {
      if(val == 1) {
        return '待开始'
      }else if(val == 2) {
        return '进行中'
      }else if(val == 3) {
        return '已结束'
      }else if(val == 0) {
        return '草稿箱'
      }
    },
    dateFormat(val, patern="YYYY-MM-DD HH:mm:ss") {
      return moment(val).format(patern)
    },
    tagFormat(val) {
      if(val == 1) {
        return '我创建'
      }else if(val == 2) {
        return '经销商'
      }else if(val == 3) {
        return '活动老师'
      }else if(val == 4) {
        return '活动管理员'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-wrapper
  min-height calc(100vh - 50px)
  background linear-gradient(180deg, #FF8820 0%, #FF6B31 100%)
  padding 0.1px
  &.gray-bg
    background #F4F4F4

.no-data
  text-align center
  color #BBBBBB
  font-size 14px
  line-height 2
  padding-top 80px
  height calc(100vh - 50px - 245px - 50px - 80px)

.swiper-content
  position relative
  .my-swipe
    >>> .van-swipe-item
      color: #fff;
      font-size: 20px;
      line-height: 150px;
      text-align: center;
      background-color: #39a9ed;
      height: 245px;
    >>> .van-swipe__indicators
      left 100%
      bottom 14px
      transform translate(-100% - 35px,0)
      position 1001
      .van-swipe__indicator
        border-radius 10px
        transition all linear .3s
        height 5px
        width 5px
      .van-swipe__indicator--active
        width 15px
        height 5px
  .title
    height 36px
    background rgba(0,0,0,0.4)
    position absolute
    width 100%
    z-index 1000
    left 0
    bottom 0
    font-size 16px
    color #fff
    line-height 36px
    padding 0 10px 
    box-sizing border-box
    text-align left !important

  
.status
  color #FF6B31
  font-size 13px
  margin-top -18px
.price
  color #FF6B31
  font-size 14px
.text-orange
  color #FF6B31

.time-icon
  margin-right 3px
  position relative
  top 1px

.process
  font-size 13px
  color #666666
  >>> .van-progress
    flex 1
    margin 0 20px
    .van-progress__pivot
      display none

.role-tag
  position absolute
  right 0
  top 0
  z-index 999
  background linear-gradient(0deg, #FF8820 0%, #FF6B31 100%)
  color rgba(255,255,255,.8)
  border-radius 0px 5px 0px 8px
  font-size 12px
  border 1px solid #FEE5B0
  padding 2px 6px
  box-shadow 0 0 5px 5px rgba(0,0,0,0.5)

.page-wrapper:not(.gray-bg)
  >>> .van-list__finished-text
    color rgba(255,255,255,.8)
  >>> .van-pull-refresh__head
    color rgba(255,255,255,.8)
  >>> .van-loading
    color rgba(255,255,255,.8)
  >>> .van-loading__text
    color rgba(255,255,255,.8)
</style>